import { hideModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { ContainerModalImage } from "./localStyle";
import { setOrden } from "_+_Portal/_-_Autocheckin/context/action/orden";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { showToaster } from "global/context/action/toaster/toaster";
import {
  resetOrdenEstudio,
  wsPostSubirOrden,
} from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import {
  limpiarListaMultimedia,
  wsGetListaMultimediaPaciente,
} from "_+_Portal/context/Actions/turnos/turnosPaciente";
import { PortalContext } from "_+_Portal/context/Provider";
import { IonSpinner } from "@ionic/react";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { getLocalStorage } from "global/utils/safeJsonParse";

const ConfirmOrden = ({
  title,
  image,
  idProtocolo,
  idturno,
  isDorso,
  loopSubirOrden,
  turnoCompleto,
  dismiss,
}) => {
  //---------------------- useStates ----------------------------
  const [loading, setLoading] = useState(false);
  //---------------------- useStates ----------------------------

  //---------------------- useContext ----------------------------
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  const { ordenDispatch, ordenState, pasoDispatch, puntoControlDispatch } =
    useContext(AutocheckContext);
  const {
    ordenEstudioDispatch,
    ordenEstudioState,
    turnosPacienteDispatch,
    turnosPacienteState,
  } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  //---------------------- useContext ----------------------------

  //---------------------- constants ----------------------------
  const descripcion = `Revise que no este movida la foto y que se vea correctamente lo solicitado <br/> <img src="${image}" alt="imagen" />`;
  let multimediaData = turnosPacienteState.turnosPaciente?.listaMultimedia;

  const pacienteCodigo = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        .codigo
    : authState.auth?.data?.paciente?.codigo;
  const config = getLocalStorage("config", {});
  let sectorTurno = config?.sectorTurno;
  //---------------------- constants ----------------------------

  //----------------------Funciones----------------------------

  const getBinario = (orden, extension) => {
    const isPng = "data:image/png;base64,";
    const isJpg = "data:image/jpg;base64,";
    const isJpeg = "data:image/jpeg;base64,";
    let binario = "";

    switch (extension) {
      case "png":
        binario = orden.replace(isPng, "");
        break;
      case "jpg":
        binario = orden.replace(isJpg, "");
        break;
      default:
        binario = orden.replace(isJpeg, "");
    }
    return binario;
  };
  const onClose = (isCorrect) => {
    if (isCorrect) {
      handleClickTwo();
      loopSubirOrden();
      resetOrdenEstudio()(ordenEstudioDispatch);
      showToaster(
        {
          texto: "Orden guardada exitosamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      handleClickTwo();
      resetOrdenEstudio()(ordenEstudioDispatch);
      setLoading(true);
      const idTipoPuntoControl = 5;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  };

  const handleClickOne = () => {
    const ordenEstudioDto = {
      binario: getBinario(image, "jpeg"),
      idremoto:
        idProtocolo !== 0 && idProtocolo !== undefined && idProtocolo !== null
          ? idProtocolo
          : idturno,
      tag: "jpeg",
    };

    if (isDorso) {
      // setOrden([...(ordenState.orden?.data ?? []), ordenEstudioDto])(ordenDispatch);
      setLoading(true);
      if (turnoCompleto.requiereAutorizacion) {
        setPaso("RequiereAutorizacion")(pasoDispatch);
        dismiss();
        setOrden([...(ordenState.orden?.data ?? []), ordenEstudioDto])(ordenDispatch);
      } else {
        wsPostSubirOrden(
          [...(ordenState.orden?.data ?? []), ordenEstudioDto],
          onClose,
          true
        )(ordenEstudioDispatch);
        limpiarListaMultimedia()(turnosPacienteDispatch);
        setOrden([])(ordenDispatch);
      }
    } else {
      setOrden([...(ordenState.orden?.data ?? []), ordenEstudioDto])(ordenDispatch);
      showToaster(
        {
          texto: "Orden guardada exitosamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };
  const handleClickTwo = () => {
    hideModal()(modalDispatch);
  };
  //----------------------Funciones----------------------------

  //---------------------- useEffects ----------------------------
  useEffect(() => {
    wsGetListaMultimediaPaciente(idturno, false, false)(turnosPacienteDispatch);
    //eslint-disable-next-line
  }, [ordenEstudioState.ordenEstudio?.data]);

  //---------------------- useEffects ----------------------------

  return (
    <ContainerModalImage>
      <span>
        Revise que no este movida la foto y que se vea correctamente lo
        solicitado{" "}
      </span>
      <img src={image} alt="imagen" />
      <div className="container-btn">
        <button className="danger" onClick={handleClickTwo}>
          Cambiar
        </button>
        <button className="success" onClick={handleClickOne}>
          {loading ? (
            <span>
              <IonSpinner name="lines" />
            </span>
          ) : (
            "Continuar"
          )}
        </button>
      </div>
    </ContainerModalImage>
  );
};

export default ConfirmOrden;
